export const useScrollStyles = (scrollbarColor: string = '#F2674A') => ({
    flex: 1,
    minHeight: 0,          // ← critical: allows flex child to shrink below content size
    overflowY: 'auto' as const,
    overflowX: 'hidden' as const,
    paddingRight: '10px',
    '&::-webkit-scrollbar': { width: '8px' },
    '&::-webkit-scrollbar-track': { background: '#FFFFFF1A', borderRadius: '10px' },
    '&::-webkit-scrollbar-thumb': {
        background: scrollbarColor,
        borderRadius: '10px',
        '&:hover': { background: scrollbarColor === '#F2674A' ? '#d9543a' : scrollbarColor },
    },
});